<app-modal-header (closeModal)="close()" [isDisabled]="isHttpRequestRunning"> </app-modal-header>
<app-modal-body>
  <div class="row">
    <div>
      @if (selectedData.url) {
        <div class="d-flex align-items-center justify-content-center overflow-auto">
          <img
            [src]="selectedData.url"
            [class]="(uploadType === UploadType.COMPANY_LOGO ? 'img-logo' : 'img-banner') + ' img-fluid mt-2'"
            width="auto"
            alt="COMPANY_LOGO"
          />
        </div>
      } @else {
        <div
          [class]="
            (uploadType === UploadType.COMPANY_LOGO ? 'd-flex' : '') +
            ' align-items-center justify-content-center overflow-auto'
          "
        >
          <div
            [class]="
              (uploadType === UploadType.COMPANY_LOGO ? 'img-logo' : 'img-banner') + ' card rounded-5 cursor-pointer'
            "
            (click)="companyImage.click()"
            (keydown)="companyImage.click()"
            tabindex="0"
          >
            <div class="card-body rounded-5 d-flex flex-column justify-content-center align-items-center bg-light">
              <p class="mb-0 text-muted fs-13px mt-2">{{ 'NO_PREVIEW_AVAILABLE' | translate }}</p>
            </div>
          </div>
        </div>
      }

      <small class="d-block text-center mt-2" [class.text-muted]="!isBgDarkMode" [class.text-white]="isBgDarkMode">
        {{ uploadType === UploadType.COMPANY_LOGO ? '250px * 250px (1MB max)' : '1200px*150px (1MB max)' }}
      </small>

      @if (lastEditInfo) {
        <small class="d-block text-center" [class.text-muted]="!isBgDarkMode" [class.text-white]="isBgDarkMode"
          >{{ 'LAST_EDIT' | translate }}: {{ lastEditInfo }}</small
        >
      }
      @if (errorMessage) {
        <p class="mb-0 text-danger fs-13px mt-2 d-flex justify-content-center">{{ errorMessage | translate }}</p>
      }
      <input
        type="file"
        class="d-none"
        id="companyImage"
        #companyImage
        accept="image/*"
        (change)="onFileChange($event)"
      />
    </div>
  </div>
</app-modal-body>
<app-modal-footer>
  <div class="d-flex justify-content-center w-100 mt-4">
    @if (selectedData.url) {
      <button
        type="button"
        class="btn btn-primary rounded-5 fw-medium text-center"
        (click)="companyImage.click()"
        [disabled]="isHttpRequestRunning"
      >
        {{ uploadType === UploadType.COMPANY_LOGO ? ('UPLOAD_LOGO' | translate) : ('UPLOAD_BANNER' | translate) }}
      </button>

      <button
        type="button"
        class="btn btn-outline-danger rounded-5 fw-medium text-center ms-3"
        (click)="removeImage()"
        [disabled]="isHttpRequestRunning"
      >
        {{ 'REMOVE' | translate }}
      </button>
    }
  </div>
</app-modal-footer>
